import { render, staticRenderFns } from "./AssignedStudentsEditModal.vue?vue&type=template&id=f7d36bac&scoped=true&"
import script from "./AssignedStudentsEditModal.vue?vue&type=script&lang=js&"
export * from "./AssignedStudentsEditModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignedStudentsEditModal.vue?vue&type=style&index=0&id=f7d36bac&prod&scoped=true&lang=css&"
import style1 from "./AssignedStudentsEditModal.vue?vue&type=style&index=1&id=f7d36bac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d36bac",
  null
  
)

export default component.exports